import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AppLoadingScreen from "../common/AppLoadingScreen";
import EssHome from "../common/EssHome";

/**
 * Original app entry: employees land on login, signed-in users stay home.
 * The sales page lives on an unlisted path, not here.
 */
function RootEntry() {
  const { isAuthenticated, isLoading, user } = useAuth();

  if (isLoading) {
    return <AppLoadingScreen message="جارٍ التحميل..." />;
  }

  if (isAuthenticated) {
    if (user?.mustChangePassword) {
      return <Navigate to="/change-password" replace />;
    }
    return <EssHome />;
  }

  return <Navigate to="/login" replace />;
}

export default RootEntry;
